import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { BUSINESS } from "@/lib/data";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-obsidian flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-surface border border-neutral-800 rounded-sm p-10 text-center">
        <div className="flex justify-center mb-6">
          <img src="/images/logo-mark.png" alt="Teign Gas" className="h-12 w-auto mix-blend-screen" />
        </div>
        <XCircle className="w-12 h-12 text-neutral-500 mx-auto mb-4" />
        <h1 className="font-display font-extrabold text-2xl text-white uppercase tracking-tight">Payment cancelled</h1>
        <p className="text-sm text-neutral-400 mt-3">
          No charge was made and your slot isn't held yet. You can try again, or call us on{" "}
          <a href={BUSINESS.phoneHref} className="text-torch hover:underline">{BUSINESS.phone}</a> and we'll book you in.
        </p>
        <Link
          to="/#booking"
          data-testid="cancel-retry-link"
          className="mt-7 inline-block bg-torch hover:bg-torch-hover text-white font-display font-bold uppercase tracking-wide px-7 py-3 rounded-sm transition-colors"
        >
          Try booking again
        </Link>
      </div>
    </div>
  );
}
